import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const rawPublicBaseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_HOST_API,
    timeout: 600000,
});

const publicBaseQuery = async (args, api, extraOptions) => {
    const result = await rawPublicBaseQuery(args, api, extraOptions);

    if (result?.error) {
        const status = result.error.status;
        const errorText = typeof result.error.error === 'string' ? result.error.error.toLowerCase() : '';
        const isOffline = typeof navigator !== 'undefined' && !navigator.onLine;

        if (
            status === 'FETCH_ERROR' ||
            isOffline ||
            errorText.includes('failed to fetch') ||
            errorText.includes('network') ||
            errorText.includes('fetch')
        ) {
            result.error.error = 'Lost connection';
        }
    }

    return result;
};

const publicAPI = createApi({
    reducerPath: 'publicAPI',
    baseQuery: publicBaseQuery,
    endpoints: (builder) => ({
        forgotPasswordRequest: builder.mutation({
            query: (payload) => ({
                url: `/api/v1/profile/reset-password`,
                method: 'POST',
                body: payload,
            }),
        }),
    }),
});

export const {
    useForgotPasswordRequestMutation,
} = publicAPI;

export default publicAPI;
